import { Flex } from "@chakra-ui/react";
import { useAnticipationStatus } from "../../hooks/useAnticipationStatus.ts";
import { Button } from "barte-design-system";
interface CancelSignatureProps {
  isCancelableSubscription: boolean
  setShowAlert: (param: boolean) => void
}

export function CancelSignature({ isCancelableSubscription, setShowAlert }: CancelSignatureProps) {
  const { hasAntecipationActive } = useAnticipationStatus()
  return (
    <>
      <Flex flexDir="column" align="flex-start" paddingTop={hasAntecipationActive ? "1rem" : ""}>
        {isCancelableSubscription && (
          <Button
            variant="link"
            disabled={hasAntecipationActive}
            id="cancelar_assinatura"
            onClick={() => setShowAlert(true)}
          >
            Cancelar recorrência
          </Button>
        )}
      </Flex>
    </>
  )
}